import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z" />,
  'SignalCellularAlt',
);
